exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".next-prev {\n    padding-top: 15px;\n    border-top: #e4e4e4 solid 1px; \n    display: -webkit-box; \n    display: -ms-flexbox; \n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n  }\n  .next-prev .btn {\n    padding: 0 1rem;\n  }\n  .next-prev .btn:first-child {\n    margin-right: 5px;\n  }\n  .tax-transactions td, .tax-transactions th { padding: 5px !important; }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-users/update-card/update-card.component.css
// module id = ../../../../../src/app/mnt-users/update-card/update-card.component.css
// module chunks = common